export const TKeyJobs = {
  JOB_FAILURE_TITLE: "JOB_FAILURE_TITLE",
  JOB_FAILURE_TITLE_PLURAL: "JOB_FAILURE_TITLE_PLURAL",
  JOB_FAILURE_MULTIPLE: "JOB_FAILURE_MULTIPLE",
  JOB_FAILURE_CALL: "JOB_FAILURE_CALL",
  JOB_FAILURE_AVATAR: "JOB_FAILURE_AVATAR",
  JOB_FAILURE_OFFER: "JOB_FAILURE_OFFER",
  JOB_FAILURE_PROSPECT: "JOB_FAILURE_PROSPECT",
  JOB_FAILURE_MESSAGE_SEQUENCE: "JOB_FAILURE_MESSAGE_SEQUENCE",
  JOB_FAILURE_REPLY_SUGGESTION: "JOB_FAILURE_REPLY_SUGGESTION",
  JOB_FAILURE_MESSAGE_SEQUENCE_STEP: "JOB_FAILURE_MESSAGE_SEQUENCE_STEP",
  JOB_FAILURE_REFUND_NOTE: "JOB_FAILURE_REFUND_NOTE",
  JOB_FAILURE_CLOSE: "JOB_FAILURE_CLOSE",
} as const;
